export default "__VITE_ASSET__DxlVdCjP__"